<template>
    <div class="mt-4">
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="table-responsive">
                    <table class="table table-striped detail-table">
                        <tbody>
                        <template v-if="isEmpty(insurance)">
                            <tr v-for="(row, index) in insurance">
                                <td class="detail-table-label">{{index | rowTitleFormat }}</td>
                                <td>{{row}}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td colspan="2">No records found</td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import TableDataExcluder from '@/mixins/table-data-excluder';

  export default {
    props: {
      patient: {
        type: Object
      }
    },

    mixins: [TableDataExcluder],
    computed: {
      insurance() {
        return this.excluder(this.patient.insurance || {}, this.excludedFields);
      }
    },

    data() {
      return {
        excludedFields: ['id']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Patient/Detail/InformationTab/InsuranceTab.vue